import { createStyles, makeStyles, Theme } from '@material-ui/core';

const MediaPreviewStyles = makeStyles(({ palette, breakpoints }: Theme) => createStyles({
  image: {
    maxWidth: '100%',
    maxHeight: '100%',
    background: '#FFF',
  },

  wrapper: {
    height: '100%',
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },

  content: {
    display: 'flex',
    alignItems: 'center',
    height: '65vh',
    width: '90vw',
    maxWidth: '100%',
    maxHeight: '100%',
    margin: 'auto',
    justifyContent: 'space-between',
    overflow: 'unset',
    textAlign: 'center',
    [breakpoints.down('sm')]: {
      padding: 'unset',
    },
  },

  contentMobile: {
    width: '100%',

    '&:first-child': {
      paddingTop: 55,
    },
  },
  contentVideoMobile: {
    '&:first-child': {
      paddingTop: 0,
    },
  },
  header: {
    minHeight: 90,
    color: '#FFF',
    padding: '20px 24px 20px 24px',
  },

  headerMobile: {
    left: 0,
    right: 0,
    position: 'absolute',
    padding: '0',
    top: 0,
    zIndex: 1,
  },

  overlay: {
    position: 'absolute',
    width: '100%',
    height: '100vh',
    background: '#000',
    opacity: 0.3,
    zIndex: -1,
    left: 0,
    right: 0,
    top: 0,
    bottom: 0,
  },

  title: {
    width: '100%',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    color: '#FFF',
    fontSize: 24,
    letterSpacing: 0.31,
    fontFamily: 'Montserrat',
    fontWeight: 500,
    paddingBottom: 10,
    [breakpoints.down('xs')]: {
      fontSize: 16,
    },
  },

  titleMobile: {
    fontSize: 16,
    paddingTop: 7,
    paddingBottom: 6,
    textAlign: 'left',
  },

  text: {
    fontSize: 16,
    whiteSpace: 'normal',
  },

  uploaded: {
    fontSize: 16,
  },

  uploadedMobile: {
    fontSize: 12,
    textAlign: 'start',
  },

  backdrop: {
    background: 'rgba(0,0,0,0.92)',
  },

  paperRoot: {
    background: 'transparent',
    boxShadow: 'unset',
    height: '100%',
    [breakpoints.down('md')]: {
      width: '100%',
      margin: 'unset',
      maxHeight: 'unset',
    },
  },

  mediaPreviewContainer: {
    width: '100%',
    height: '100%',
    maxWidth: 'calc(100% - 140px)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    overflowX: 'hidden',
    touchAction: 'none',
    overflowScrolling: 'none',
    overflow: 'hidden',
  },

  mediaPreviewContainerMobile: {
    maxWidth: '100%',
  },

  noselect: {
    WebkitTouchCallout: 'none',
    WebkitUserSelect: 'none',
    KhtmlUserSelect: 'none',
    MozUserSelect: 'none',
    msUserSelect: 'none',
    userSelect: 'none',
  },

  playerWrapper: {
    maxWidth: '100%',
    height: '100%',
  },
  mobilePlayerWrapper: {
    display: 'flex',
    flexDirection: 'column',
  },
  titleWrapper: {
    maxWidth: 'calc(100% - 220px)',
  },
  mobileTitleWrapper: {
    maxWidth: 'calc(100% - 105px)',
  },
  controlsWrapper: {
    width: 'auto',
    justifyContent: 'flex-end',
    margin: '0 0 0 auto',
  },
}), { name: 'MediaPreview' });

export default MediaPreviewStyles;
